// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#270B4B"
      d="M20.0012 15C20.0012 14.4477 19.5535 14 19.0012 14C18.4489 14 18.0012 14.4477 18.0012 15V17H16.0012C15.4489 17 15.0012 17.4477 15.0012 18C15.0012 18.5523 15.4489 19 16.0012 19H18.0012V21C18.0012 21.5523 18.4489 22 19.0012 22C19.5535 22 20.0012 21.5523 20.0012 21V19H22.0012C22.5535 19 23.0012 18.5523 23.0012 18C23.0012 17.4477 22.5535 17 22.0012 17H20.0012V15Z"
    />
    <path
      fill="#270B4B"
      fillRule="evenodd"
      d="M12.1822 14.1635C12.4645 14.3073 12.6939 14.5368 12.8377 14.819 12.9908 15.1194 13.0014 15.4476 13.0012 15.7769 13.0012 15.7847 13.0012 15.7924 13.0012 15.8 13.0012 17.2744 13.0007 18.7488 13.0012 20.2231 13.0013 20.3422 13.0013 20.4845 12.9911 20.6098 12.9792 20.755 12.9488 20.963 12.8377 21.181 12.6939 21.4632 12.4645 21.6927 12.1822 21.8365 11.9643 21.9476 11.7563 21.978 11.6111 21.9899 11.4857 22.0001 11.3435 22.0001 11.2244 22 8.40892 21.999 5.59348 21.999 2.77804 22 2.65877 22.0001 2.51621 22.0001 2.39058 21.9898 2.24486 21.9778 2.03645 21.9472 1.81817 21.8356 1.53557 21.6911 1.3055 21.46 1.16231 21.1767 1.05201 20.9585 1.02209 20.7506 1.01073 20.6046 1.00096 20.4791 1.00166 20.3369 1.00225 20.2185 1.00741 19.1792.976424 18.0653 1.38183 17.0866 1.8893 15.8614 2.86267 14.8881 4.08781 14.3806 4.59751 14.1695 5.13579 14.0819 5.74453 14.0404 6.33654 14 7.06395 14 7.96571 14 9.05193 14 10.1381 14.0004 11.2244 14 11.5536 13.9999 11.8818 14.0104 12.1822 14.1635ZM14.5743 2.91554C14.7815 2.40361 15.3645 2.1566 15.8764 2.36382 17.707 3.10481 19.0012 4.90006 19.0012 7 19.0012 9.09994 17.707 10.8952 15.8764 11.6362 15.3645 11.8434 14.7815 11.5964 14.5743 11.0845 14.3671 10.5725 14.6141 9.98953 15.126 9.7823 16.2273 9.33652 17.0012 8.25744 17.0012 7 17.0012 5.74256 16.2273 4.66348 15.126 4.2177 14.6141 4.01047 14.3671 3.42748 14.5743 2.91554Z"
      clipRule="evenodd"
    />
    <path
      fill="#270B4B"
      fillRule="evenodd"
      d="M4.50123 7C4.50123 4.23858 6.7398 2 9.50123 2C12.2627 2 14.5012 4.23858 14.5012 7C14.5012 9.76142 12.2627 12 9.50123 12C6.7398 12 4.50123 9.76142 4.50123 7Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconUsersPlus = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUsersPlus;
